import initLayout from './modules/layout';
import initAjaxPagination from './modules/ajax_pagination';
import initHero from './modules/home-hero';
import initDataArchCarousel from './modules/home-data-arch';
import initProjectPaths from './modules/home-project-paths';
import initHomeFeaturesCarousel from './modules/home-features-carousel';
import initHomeBlogCarousel from './modules/home-blog-carousel';
import initCodeHighlight from './modules/code-highlight';
import initFooterSocials from './modules/footer-socials';

// Init hero if canvas is present on this page
if ( document.getElementById( 'hero-canvas' ) ) {
	initHero();
}

initDataArchCarousel();
initProjectPaths();
initHomeFeaturesCarousel();
initHomeBlogCarousel();
initCodeHighlight();
initFooterSocials();
initLayout();
initAjaxPagination();
